import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "app-analysis"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "团队", -1);

const _hoisted_5 = {
  class: "toolbox"
};
const _hoisted_6 = {
  class: "wrapper"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "时间", -1);

const _hoisted_8 = {
  class: "wrapper"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "排名规则", -1);

const _hoisted_10 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_12 = {
  class: "analysis-dashboard"
};
const _hoisted_13 = {
  class: "card"
};
const _hoisted_14 = {
  class: "wrapper"
};

const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "登录日活", -1);

const _hoisted_16 = {
  class: "value"
};
const _hoisted_17 = {
  class: "wrapper"
};

const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "新日活用户", -1);

const _hoisted_19 = {
  class: "value"
};
const _hoisted_20 = {
  class: "card"
};
const _hoisted_21 = {
  class: "wrapper"
};

const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "药企/国代日活用户", -1);

const _hoisted_23 = {
  class: "value"
};
const _hoisted_24 = {
  class: "wrapper"
};

const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "销售团队管理者日活用户", -1);

const _hoisted_26 = {
  class: "value"
};
const _hoisted_27 = {
  class: "wrapper"
};

const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "销售团队业务员日活用户", -1);

const _hoisted_29 = {
  class: "value"
};
const _hoisted_30 = {
  class: "card"
};
const _hoisted_31 = {
  class: "wrapper"
};

const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "商业公司日活用户", -1);

const _hoisted_33 = {
  class: "value"
};
const _hoisted_34 = {
  class: "wrapper"
};

const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "商业公司日活用户（新用户）", -1);

const _hoisted_36 = {
  class: "value"
};
const _hoisted_37 = {
  class: "card"
};
const _hoisted_38 = {
  class: "wrapper"
};

const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "访问用户总数", -1);

const _hoisted_40 = {
  class: "value"
};
const _hoisted_41 = {
  class: "wrapper"
};

const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "访问总次数", -1);

const _hoisted_43 = {
  class: "value"
};
const _hoisted_44 = ["onClick"];

const _hoisted_45 = /*#__PURE__*/_createTextVNode("关闭");

import { ref, onMounted } from 'vue';
import { getTeamList, getTrackData, getTrackCountData, getTrackAccountDetail } from '@/request';
import { getVexTableProps } from '@/config';
import dayjs from 'dayjs';
export default {
  name: 'app',

  setup(__props) {
    const currentDate = dayjs();
    const dateRange = ref([currentDate.subtract(7, 'day').format('YYYY-MM-DD'), currentDate.format('YYYY-MM-DD')]);
    const queryType = ref('');
    const queryTypeList = [{
      name: '按访问用户',
      value: 1
    }, {
      name: '按访问次数',
      value: 2
    }];
    const supplierList = ref([]);
    const supplierIds = ref([]);
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '功能使用排名',
        field: 'eventRank',
        width: 120
      }, {
        title: '事件名称',
        field: 'eventName'
      }, {
        title: '访问用户',
        field: 'userName',
        slots: {
          default: 'link'
        }
      }, {
        title: '访问次数',
        field: 'recordCount'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => {
            let querySupplierIds = supplierIds.value || [];
            getDashboard();
            return new Promise(res => {
              getTrackData({
                startDate: dateRange.value[0],
                endDate: dateRange.value[1],
                page: page.currentPage,
                rows: page.pageSize,
                queryType: queryType.value,
                supplierIds: querySupplierIds.join(",")
              }).then(data => {
                res({
                  total: data.data.total,
                  result: data.data.rows
                });
              });
            });
          }
        }
      }
    });

    function reset() {
      dateRange.value = [];
      queryType.value = '';
      table.value.commitProxy('reload');
    }

    const dashboardData = ref({});

    function getDashboard() {
      let querySupplierIds = supplierIds.value || [];
      let params = {
        startDate: dateRange.value[0],
        endDate: dateRange.value[1],
        supplierIds: querySupplierIds.join(",")
      };
      return getTrackCountData(params).then(res => {
        dashboardData.value = res.data;
      });
    }

    const dialogShow = ref(false);
    const dialogTable = ref([]);
    const dialogColumns = [{
      label: '团队名称',
      prop: 'supplierNames',
      width: 650
    }, {
      label: '登录账号',
      prop: 'loginName',
      width: 150
    }, {
      label: '联系人',
      prop: 'linkMan',
      widht: 160
    }];

    function checkUserDetail(data) {
      dialogShow.value = true;
      let querySupplierIds = supplierIds.value || [];
      let params = {
        startDate: dateRange.value[0],
        endDate: dateRange.value[1],
        eventId: data.eventId,
        supplierIds: querySupplierIds.join(",")
      };
      getTrackAccountDetail(params).then(res => {
        dialogTable.value = res.data;
      });
    }

    getTeamList({
      rows: 1000
    }).then(data => {
      if (data.rows) {
        supplierList.value = data.rows.map(item => ({
          supplierName: item.supplier_name,
          supplierId: item.supplier_id
        }));
      }
    }); // const getSupplierList = async () => {
    //     try {
    //         const data = await getTeamList({ rows: 1000 });
    //         if (data) {
    //             supplierList.value = data.rows.map(item => ({ supplierName: item.supplier_name, supplierId: item.supplier_id }));
    //         }
    //     } catch (error) {
    //         console.error('获取团队列表失败:', error);
    //     }
    // };
    // onMounted(() => {
    //     getDashboard()
    // })

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_select, {
        modelValue: supplierIds.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => supplierIds.value = $event),
        style: {
          "width": "1200px"
        },
        filterable: "",
        multiple: "",
        placeholder: "请选择"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, supplier => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: supplier.supplierName,
            value: supplier.supplierId,
            key: supplier.supplierId
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_date_picker, {
        modelValue: dateRange.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dateRange.value = $event),
        type: "daterange",
        "value-format": "YYYY-MM-DD",
        style: {
          "flex": "0 0 300px"
        },
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        "unlink-panels": ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_select, {
        modelValue: queryType.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryType.value = $event)
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(queryTypeList, item => {
          return _createVNode(_component_el_option, {
            value: item.value,
            label: item.name,
            key: item.value
          }, null, 8, ["value", "label"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_10]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      })]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", _hoisted_16, _toDisplayString(dashboardData.value.totalUserCount) + "人", 1)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("span", _hoisted_19, _toDisplayString(dashboardData.value.totalNewUserCount) + "人", 1)])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("span", _hoisted_23, _toDisplayString(dashboardData.value.totalBuinessUserCount) + "人（新用户：" + _toDisplayString(dashboardData.value.totalBuinessNewUserCount) + "人）", 1)]), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("span", _hoisted_26, _toDisplayString(dashboardData.value.totalManagerUserCount) + "人（新用户：" + _toDisplayString(dashboardData.value.totalManagerNewUserCount) + "人）", 1)]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("span", _hoisted_29, _toDisplayString(dashboardData.value.totalSalesmanUserCount) + "人（新用户：" + _toDisplayString(dashboardData.value.totalSalesmanNewUserCount) + "人）", 1)])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("span", _hoisted_33, _toDisplayString(dashboardData.value.totalStoreUserCount) + "人", 1)]), _createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("span", _hoisted_36, _toDisplayString(dashboardData.value.totalStoreNewUserCount) + "人", 1)])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("span", _hoisted_40, _toDisplayString(dashboardData.value.totalSumUserCount) + "人", 1)]), _createElementVNode("div", _hoisted_41, [_hoisted_42, _createElementVNode("span", _hoisted_43, _toDisplayString(dashboardData.value.totalSumCount) + "次", 1)])])]), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        link: _withCtx(({
          row
        }) => [_createElementVNode("a", {
          class: "link",
          href: "javascript:;",
          onClick: $event => checkUserDetail(row)
        }, _toDisplayString(row.userName), 9, _hoisted_44)]),
        _: 1
      }, 16), _createVNode(_component_el_dialog, {
        modelValue: dialogShow.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => dialogShow.value = $event),
        title: "详情",
        top: "50px",
        width: "1000px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => dialogShow.value = false)
        }, {
          default: _withCtx(() => [_hoisted_45]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: dialogTable.value,
          height: "600px"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(dialogColumns, item => {
            return _createVNode(_component_el_table_column, {
              key: item.prop,
              label: item.label,
              prop: item.prop,
              width: item.width
            }, null, 8, ["label", "prop", "width"]);
          }), 64))]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};